export default __webpack_public_path__ + "2b50ea936cf6fd46eb160e6c385bce31.svg";